// extracted by mini-css-extract-plugin
module.exports = {"dumb_1":"RandomArticles_dumb_1__i0Ogm","dumb_2":"RandomArticles_dumb_2__U__1R","header":"RandomArticles_header__Q3aZA"};